import useSlug from 'hooks/useSlug'
import { isPresent } from 'lib/utils'
import { useEffect, useMemo, useState } from 'react'

let DeliveryView = ({
  content,
  name,
}: {
  content: string[]
  name?: string
}) => {
  const { showOnlyContent } = useSlug()

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMounted(true)
    }
  }, [])

  useEffect(() => {
    if (isMounted) {
      const mapScript = document.querySelector(
        '.map script'
      ) as HTMLScriptElement
      const body = document.getElementsByTagName('body')[0]
      if (isPresent(body) && isPresent(mapScript)) {
        const script = document.createElement('script')
        script.id = 'delivery_yadexmap_script'
        script.type = 'text/javascript'
        script.src = mapScript.src
        body.appendChild(script)
      }
    }
  }, [isMounted])

  const content1 = useMemo(
    () =>
      showOnlyContent
        ? (content[1] ?? '')?.replace(
            'href="/personal"',
            'href="/personal?content-only=1"'
          )
        : content[1] ?? '',
    [content[1], showOnlyContent]
  )

  return (
    <div className='mb-12 custom-px'>
      <h1 className='mb-4 pt-4 lg:pt-0 font-unbounded text-2xl lg:text-5xl tracking-tight md:tracking-tight leading-snug md:leading-snug'>
        {name || 'Доставка и возврат'}
      </h1>
      {isMounted && (
        <div
          dangerouslySetInnerHTML={{ __html: content[0] ?? '' }}
        ></div>
      )}

      <div dangerouslySetInnerHTML={{ __html: content1 }}></div>

      <div
        dangerouslySetInnerHTML={{ __html: content[2] ?? '' }}
      ></div>
    </div>
  )
}

export default DeliveryView
